import React from "react";
import {
  KID_HOURS_TRACKING_LABEL,
  getKidHoursTrackingStatusLabel,
} from "../shared/utils/kidHoursTrackingStatus";

/**
 * Display-only Kid Hours status: "Kid Hours:" label + Tracked/Not Tracked badge
 * (same layout pattern as EventCardPriceMeta / EventPriceBadge).
 * Tracked = Current AOP program; Not Tracked = outside Current AOP.
 *
 * @param {{ tracked: boolean, className?: string }} props
 */
export default function KidHoursTrackingStatus({ tracked = false, className = "" }) {
  const statusLabel = getKidHoursTrackingStatusLabel(tracked);
  const tone = tracked ? "tracked" : "not-tracked";
  const badgeClass = [
    "kid-hours-tracking-status",
    `kid-hours-tracking-status--${tone}`,
  ].join(" ");
  const rootClass = ["card-meta", className].filter(Boolean).join(" ");

  return (
    <div className={rootClass}>
      <span className="card-meta-label">{KID_HOURS_TRACKING_LABEL}:</span>
      <span
        className={badgeClass}
        role="status"
        aria-label={`${KID_HOURS_TRACKING_LABEL}: ${statusLabel}`}
      >
        {statusLabel}
      </span>
    </div>
  );
}
